export { default } from './TableShimmer.component';
export type { TableShimmerProps } from './TableShimmer.component';
